import React from 'react';
import { css } from 'react-emotion';
import { flex } from 'appStyles';

import { RotatingImageGalleryComponent, PictureCatalogComponent, TextComponent } from 'components';


const TemplateComponent = props => {

  const { type, view, setTemplate, componentNumber } = props;
  switch(type){
    case 'text':
      return <TextComponent { ...view } 
        setTemplate={setTemplate} 
        componentNumber={componentNumber}/>;
    case 'rotatingImageGallery':
      return <RotatingImageGalleryComponent { ...view } 
        setTemplate={setTemplate} 
        componentNumber={componentNumber}/>;
    case 'pictureCatalog':
      return <PictureCatalogComponent { ...view } 
        setTemplate={setTemplate} 
        componentNumber={componentNumber}/>;
    default:
      return null;
  }
};

export default TemplateComponent;
